import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborModel} from "../../server/PearlHarborModel";


export class FreespinRoundWinRunner implements FlowStatePresentation {
    private _tl: TimelineLite

    private skip(): void {

    }

    public shouldRun(): boolean {
        const model: PearlHarborModel = PearlHarbor.model;
        if(model.dogfight === undefined){
            return false;
        }
        return true;
    }

    private completePresentation(flowStateController: FlowStateController) {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController): void {
        this._tl = new TimelineLite();
        this._tl.add(() => flowStateController.setSkipCallback(() => {}), 0.1);

        this._tl.add(PearlHarbor.cocpitBoard.updateAllMetersWin());
        this._tl.add(() => {}, 0.1);
        this._tl.add(() => this.completePresentation(flowStateController));
    }


}